import actionTypes from "./actionTypes";
import api from "./api";
export default {
    setInnerObjectsSelectedIds: (selected, documentId, documentType) => ({
        type: actionTypes.SET_INNER_OBJECTS_SELECTED,
        selected,
        documentId,
        documentType
    }),
    getGraphNodeImageContent: (largeAttributeId, completed, rejected) => ({
        type: actionTypes.GET_GRAPH_NODE_IMAGE_CONTENT,
        payload: {
            promise: () => api.getGraphNodeImageContent(largeAttributeId)
        },
        scope: `${actionTypes.GET_GRAPH_NODE_IMAGE_CONTENT}_${largeAttributeId}`,
        completed: (_, { payload }) => {
            completed && completed(payload);
        },
        rejected: () => {
            rejected && rejected();
        }
    }),
    setReadOnlyMode: (documentId, readOnlyMode) => ({
        type: actionTypes.SET_READONLY_MODE,
        documentId,
        readOnlyMode
    }),
    getTaskResultLimit: (documentId) => ({
        type: actionTypes.GET_TASK_RESULT_LIMIT,
        payload: {
            promise: () => api.getDocumentTaskResultLimit(documentId)
        },
        meta: { documentId },
        scope: `${actionTypes.GET_TASK_RESULT_LIMIT}_${documentId}`
    }),
    saveTaskResultLimit: (documentId, taskResultLimit) => ({
        type: actionTypes.SAVE_TASK_RESULT_LIMIT,
        payload: {
            promise: () => api.saveDocumentTaskResultLimit(documentId, taskResultLimit)
        },
        meta: { documentId, taskResultLimit },
        scope: `${actionTypes.SAVE_TASK_RESULT_LIMIT}_${documentId}`
    })
};
